import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M429-212q-16 0-28-11-11-11-11-28t11-28 28-12h102q17 0 28 12t11 29q0 16-11 27-12 11-28 11H429ZM267-441q-17 0-28-11t-11-28q0-17 11-28 11-12 28-12h426q17 0 28 12t11 28q0 17-11 28t-28 11H267ZM145-670q-17 0-28-11t-11-28q0-17 11-28 12-12 28-12h670q17 0 28 12 12 11 12 28t-12 28q-12 11-28 11H145Z"/>',
  f: '<path d="M429-212q-16 0-28-11-11-11-11-28t11-28 28-12h102q17 0 28 12t11 29q0 16-11 27-12 11-28 11H429ZM267-441q-17 0-28-11t-11-28q0-17 11-28 11-12 28-12h426q17 0 28 12t11 28q0 17-11 28t-28 11H267ZM145-670q-17 0-28-11t-11-28q0-17 11-28 12-12 28-12h670q17 0 28 12 12 11 12 28t-12 28q-12 11-28 11H145Z"/>',
};

export default data;
